import { fromJS } from 'immutable';
import RecordsForMonth from '../domain/transits/RecordsForMonth';
import pathToUpdate from '../type/pathToUpdate';

export const createRecord = (
  recordsForMonth: RecordsForMonth,
  path: pathToUpdate
): RecordsForMonth => {
  // todo endTime と startTime 0 は適当なので、本来は選択した日付の朝9時とかにすべきか？
  const defaultRecord = {
    from: {
      dist: '',
      endTime: 0,
      startTime: 0,
      station: '',
      zonedEndTime: '',
      zonedStartTime: ''
    },
    to: {
      dist: '',
      endTime: 0,
      startTime: 0,
      station: '',
      zonedEndTime: '',
      zonedStartTime: ''
    },
    cost: {
      url: '',
      title: '',
      cost: 0,
      paths: []
    }
  };
  const records = fromJS(recordsForMonth)
    .getIn(path)
    .push(defaultRecord);
  return updateRecord(recordsForMonth, path, records);
};

export function updateRecord<T>(
  recordsForMonth: RecordsForMonth,
  path: pathToUpdate,
  value: T
): RecordsForMonth {
  return fromJS(recordsForMonth)
    .updateIn(path, () => value)
    .toJS();
}

export const deleteRecord = (
  recordsForMonth: RecordsForMonth,
  path: pathToUpdate
): RecordsForMonth => {
  const index = path.pop();
  const records = fromJS(recordsForMonth)
    .getIn(path)
    .delete(index)
    .toJS();
  return updateRecord(recordsForMonth, path, records);
};

export const addPath = (
  pathArray: pathToUpdate,
  addingPath: pathToUpdate
): pathToUpdate => {
  const copied = fromJS(pathArray).toJS();
  addingPath.map(item => {
    copied.push(item);
  });
  return copied;
};



// WEBPACK FOOTER //
// ./src/logic/service/RecordsForMonthService.ts